import React, {useState} from 'react';
import {Box, Button} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PropTypes from 'prop-types';
import SettingsPills from './SettingsPills';
import SchoolUsers from './SchoolUsers/SchoolUsers';
import SchoolMembersSetup from '../../SchoolManagement/Setup/SchoolMembersSetup';
import ContactInvites from '../../SchoolManagement/Setup/ContactInvites';

// Maria, 20 October 2026: Users, User Invites and Parent Invitations under one 'Manage Users' tab, with a button for each
export const USER_PARTS = ['All Users', 'User Invitations', 'Parent Invitations'];

const ManageUsersTab = ({schoolInfo, initialPart}) => {
    const [part, setPart] = useState(USER_PARTS.includes(initialPart) ? initialPart : USER_PARTS[0]);
    const [addRequest, setAddRequest] = useState(0);

    // Maria, 20 October 2026: 'Add User' on the row of buttons, at the right, as 'Assign Permissions' is on Manage Access
    const addUserButton = part === 'User Invitations' && (
        <Button
            variant="contained"
            startIcon={<AddCircleOutlineIcon/>}
            onClick={() => setAddRequest(n => n + 1)}
            data-testid="add-user"
            sx={{backgroundColor: '#186BBE', boxShadow: 'none', py: 0.25, px: 1.25, fontSize: 12, '&:hover': {backgroundColor: '#155FA7', boxShadow: 'none'}}}
        >
            Add User
        </Button>
    );

    return (
        <Box>
            <SettingsPills value={part} options={USER_PARTS} onChange={setPart} testId="manage-users-parts" end={addUserButton}/>
            {part === 'All Users' && <SchoolUsers/>}
            {part === 'User Invitations' && <SchoolMembersSetup schoolInfo={schoolInfo} addRequest={addRequest} inManageUsers/>}
            {part === 'Parent Invitations' && <ContactInvites/>}
        </Box>
    );
};

ManageUsersTab.propTypes = {
    schoolInfo: PropTypes.object,
    initialPart: PropTypes.string
};

export default ManageUsersTab;
